<template>
  <div>
    <ul class="px-0">
      <li v-for="(lang, i) in supportedLanguages" :key="lang">
        <router-link
          class="text-uppercase language-link"
          :class="{ 'font-weight-bold': isSelected(lang) }"
          :to="{ name: $router.name || 'home', params: { locale: lang } }"
          >{{ lang }}</router-link
        >
        <span v-if="i !== supportedLanguages.length - 1">&nbsp;|&nbsp;</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { supportedLanguages } from "@/locales/languages.js";
export default {
  data() {
    return {
      supportedLanguages
    };
  },
  methods: {
    isSelected(language) {
      return language === this.$i18n.locale;
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
}

li {
  display: inline-block;
}

.language-link {
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: 0.5s border-color;
}

.language-link:hover {
  border-bottom: 1px solid #fff;
}
</style>